import React from 'react';
import Dropbox from '../../Dropbox';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/esm/Form';
import Container from 'react-bootstrap/esm/Container';
import { DualBandLinkReferenceContext, DualBandLinkUserContext } from '../../../contexts/DualBandLinkContext';

/**
 * Dual band antenna detail component
 * ONLY for the dual band
 */
export default class DualBandAntennaDetails extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
    }

    /**
     * Function called when the antenna is changed
     * @param link  user's data
     * @param newData New data which has been selected
     * @param site it's a tag to define the site of the antenna (e.g. site 1, site 2...)
     */
    onChangeAntenna(link: Readonly<any>, newData: {}) {
        link.define("equipDualBandAntenna", newData);
    }


    render() {
        return (
        <Container>
            <DualBandLinkUserContext.Consumer>
                {(link) => (
                    <>
                    <DualBandLinkReferenceContext.Consumer>
                        {(linkRef) => (
                            <>
                                <Row>
                                    <Col>
                                        <Form.Label>Dual band antenna</Form.Label>
                                        <Dropbox 
                                        uniqueKey="idAntenna" 
                                        displayInputKey="label"
                                        showStartedKey={link?.edit}
                                        startedKey={link?.equipDualBandAntenna?.idAntenna}
                                        values={(linkRef.equipNorms != null && link.equipFreq != null) ? link.dualBandAntennas : []} 
                                        onChange={(newData) => this.onChangeAntenna(link, newData)}
                                        />
                                    </Col>              
                                </Row>
                            </>
                        )}
                    </DualBandLinkReferenceContext.Consumer>
                    </>
                )}
            </DualBandLinkUserContext.Consumer>
        </Container>
        );
    }

}